import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { useSection } from "../../lib/content";

export const Rooms = () => {
  const c = useSection("rooms");

  return (
    <section id="room-solutions" className="relative bg-white py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHead chapter="09" eyebrow={c.eyebrow} title={c.title} lead={c.lead} />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {c.rooms.map((room, i) => (
            <Reveal key={`${room.type}-${i}`} delay={i * 0.1} className="h-full">
              <div data-testid={`room-card-${i}`} className="group h-full rounded-2xl overflow-hidden border border-[#2a2a2a] bg-[#1a1a1a] transition-[transform,box-shadow] duration-400 hover:-translate-y-2 hover:shadow-[0_32px_64px_-24px_rgba(15,23,42,0.3)]">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={room.img}
                    alt={room.type}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-108"
                    style={{ transform: "scale(1.02)" }}
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/50 to-transparent" />
                  <span className="absolute top-4 left-4 bg-white/90 backdrop-blur font-mono text-[10px] font-bold uppercase tracking-[0.12em] text-slate-900 px-2.5 py-1 rounded-full">
                    0{i + 1}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-base sm:text-lg font-bold tracking-tight text-white leading-snug">
                    {room.type}
                  </h3>
                  <p className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-white">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#024AD8]" />
                    {room.device}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
